// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  ratingFeature:false,
  numberOfViewsFeature:false,
  feesFeature:false,
  bookingFeature:false,
  apiURI: "https://events.globalistic.tech/api/",
  hostURI: "https://events.globalistic.tech/",
  key: "abcdefgh123456789",
  ipifyURI: "https://api.ipify.org/?format=json",
  ipgeolocationURI: "https://api.ipgeolocation.io/ipgeo?",
  ipgeolocationKEY: "b0bcda3d31ab4a969d0521afc39ac166"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
